/* SessionStatusIcon.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02xpxF%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
import React from 'react';
import QuestionCircleFilledIcon from '@atlaskit/icon-lab/core/question-circle-filled';
export type SessionStatus = 'needs-input';
export type SessionStatusIconSize = 12 | 16;
export type SessionStatusIconProps = {
  status: SessionStatus;
  label?: string;
  /** CSS color for the filled icon. Defaults to the blue brand icon token. */
  color?: string;
  /** Visual size for the icon. Defaults to 12. */
  iconSize?: SessionStatusIconSize;
  testId?: string;
};
const styles = {
  icon: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC"
};
const iconSizeStyles = {
  12: "_39xV02xpxF _0jFU0VxpxF",
  16: "_39xV02ey7F _0jFU0Vey7F"
};
export const SessionStatusIcon = ({
  status,
  label = '',
  color = "var(--ds-icon-brand, #1868DB)",
  iconSize = 12,
  testId
}: SessionStatusIconProps): React.JSX.Element | null => {
  if (status === 'needs-input') {
    return <span data-testid={testId} style={{
      color
    }} className={ax([styles.icon, iconSizeStyles[iconSize]])}>
				<QuestionCircleFilledIcon label={label} size="small" />
			</span>;
  }
  return null;
};